import { takeEvery } from 'redux-saga/effects'
import {
  accountConstants,
  audienceConstants,
  authConstants,
  organizationConstants,
  campaignConstants,
  templateConstants,
  statsConstants
} from '../constants'
import {
  loginGithubSaga,
  loginGoogleSaga,
  loginMicrosoftSaga,
  validateAuthSaga,
  logoutUserSaga
} from './auth.sagas'
import {
  organizationJoinSaga,
  organizationLoadSaga,
  organizationSaveSaga
} from './organization.sagas'
import {
  accountLoadSaga,
  accountSaveSaga,
  accountDeleteSaga
} from './account.sagas'
import {
  audienceLoadSaga,
  audienceSaveSaga,
  audienceDeleteSaga
} from './audience.sagas'
import {
  campaignLoadSaga,
  campaignSaveSaga,
  campaignDeleteSaga,
  campaignBackToDraftSaga
} from './campaign.sagas'
import {
  templateLoadSaga,
  templateSaveSaga,
  templateDeleteSaga
} from './template.sagas'
import { statsLoadSaga, statsCampaignLoadSaga } from './stats.sagas'

export function* watchAuth() {
  yield takeEvery(authConstants.AUTH_LOGIN_GOOGLE, loginGoogleSaga)
  yield takeEvery(authConstants.AUTH_LOGIN_GITHUB, loginGithubSaga)
  yield takeEvery(authConstants.AUTH_LOGIN_MICROSOFT, loginMicrosoftSaga)
  yield takeEvery(authConstants.AUTH_VALIDATE, validateAuthSaga)
  yield takeEvery(authConstants.AUTH_LOGOUT, logoutUserSaga)
}

export function* watchOrganization() {
  yield takeEvery(organizationConstants.ORGANIZATION_LOAD, organizationLoadSaga)
  yield takeEvery(organizationConstants.ORGANIZATION_SAVE, organizationSaveSaga)
  yield takeEvery(organizationConstants.ORGANIZATION_JOIN, organizationJoinSaga)
}

export function* watchAccount() {
  yield takeEvery(accountConstants.ACCOUNT_LOAD, accountLoadSaga)
  yield takeEvery(accountConstants.ACCOUNT_SAVE, accountSaveSaga)
  yield takeEvery(accountConstants.ACCOUNT_DELETE, accountDeleteSaga)
}

export function* watchAudience() {
  yield takeEvery(audienceConstants.AUDIENCE_LOAD, audienceLoadSaga)
  yield takeEvery(audienceConstants.AUDIENCE_SAVE, audienceSaveSaga)
  yield takeEvery(audienceConstants.AUDIENCE_DELETE, audienceDeleteSaga)
}

export function* watchCampaign() {
  yield takeEvery(campaignConstants.CAMPAIGN_LOAD, campaignLoadSaga)
  yield takeEvery(campaignConstants.CAMPAIGN_SAVE, campaignSaveSaga)
  yield takeEvery(campaignConstants.CAMPAIGN_DELETE, campaignDeleteSaga)
  yield takeEvery(
    campaignConstants.CAMPAIGN_BACK_TO_DRAFT,
    campaignBackToDraftSaga
  )
}

export function* watchTemplate() {
  yield takeEvery(templateConstants.TEMPLATE_LOAD, templateLoadSaga)
  yield takeEvery(templateConstants.TEMPLATE_SAVE, templateSaveSaga)
  yield takeEvery(templateConstants.TEMPLATE_DELETE, templateDeleteSaga)
}

export function* watchStats() {
  yield takeEvery(statsConstants.STATS_LOAD, statsLoadSaga)
  yield takeEvery(statsConstants.STATS_CAMPAIGN_LOAD, statsCampaignLoadSaga)
}
